import DateFunc from '@/lib/lyg/date_func';
import WriteCounselTodoArea from "@/pages/comp/basic/counsel/common/write_counsel_todo";

function WriteCounselTodoPopup(props: any){
  let myProps = {
    closePopup: () => { },
    callback: () => { },
    stu_info_arr: [],
    start_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    end_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    ...props
  };

  return (
    <div>
      <WriteCounselTodoArea
        closePopup={myProps.closePopup}
        callback={myProps.callback}
        stu_info_arr={myProps.stu_info_arr}
        start_date={myProps.start_date}
        end_date={myProps.end_date}
      ></WriteCounselTodoArea>
    </div>
  );
};
export default WriteCounselTodoPopup;